export default __webpack_public_path__ + "static/service-1-7ade690ce183e79ece79f011c1869bac.webp";